import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    state: { isFavouriteLoading },
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodities, setCommodities] = useParameter<number>("@commodities");
  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");

  useEffect(() => {
    setParameters(title, {
      "@business-units": business,
      "@commodities": commodities,
      "@commodities_display": commodityDisplay,
    });
  }, [title, business, commodities, commodityDisplay, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setBusiness(parameters["@business-units"].map(Number)[0]);
      setCommodities(parameters["@commodities"].map(Number)[0]);
      setCommodityDisplay(parameters["@commodities_display"].map(Number)[0]);
    },
    [setBusiness, setCommodities, setCommodityDisplay]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);

  return { isFavouriteLoading };
}
